import { Extrapolation, interpolate } from "react-native-reanimated";
export function parallaxLayout(baseConfig, modeConfig = {}) {
    const { size, vertical } = baseConfig;
    const { parallaxScrollingOffset = 100, parallaxScrollingScale = 0.8, parallaxAdjacentItemScale = parallaxScrollingScale ** 2, } = modeConfig;
    return (value) => {
        "worklet";
        const translate = interpolate(value, [-1, 0, 1], [-size + parallaxScrollingOffset, 0, size - parallaxScrollingOffset]);
        const zIndex = Math.round(interpolate(value, [-1, 0, 1], [0, size, 0], Extrapolation.CLAMP));
        const scale = interpolate(value, [-1, 0, 1], [parallaxAdjacentItemScale, parallaxScrollingScale, parallaxAdjacentItemScale], Extrapolation.CLAMP);
        return {
            transform: [
                vertical
                    ? {
                        translateY: translate,
                    }
                    : {
                        translateX: translate,
                    },
                {
                    scale,
                },
            ],
            zIndex,
        };
    };
}
//# sourceMappingURL=paralax.js.map